import {useEffect} from "react";
import {useSetAtom} from "jotai";
import {useTranslation} from "react-i18next";
import {useLoadableValueOrDefault} from "./jotaiHooks";
import {UserPreferences} from "../types/domain/user";
import {authenticatedUserPreferencesLoadable, authenticatedUserTableLocaleAtom} from "../store/authenticatedUserStore";
import {DEFAULT_USER_PREFERENCES, languageTypeToLocale, languageTypeToTableLocale} from "../utils/userUtils";

export const useI18nLanguage = () => {
    const {i18n} = useTranslation();
    const userPreferences = useLoadableValueOrDefault<UserPreferences | undefined>(
        authenticatedUserPreferencesLoadable,
        DEFAULT_USER_PREFERENCES,
    );
    const setTableLocale = useSetAtom(authenticatedUserTableLocaleAtom);

    useEffect(() => {
        if (userPreferences?.language) {
            void i18n.changeLanguage(languageTypeToLocale(userPreferences?.language));
            setTableLocale(languageTypeToTableLocale(userPreferences?.language));
        }
    }, [userPreferences, i18n, setTableLocale]);
};
